// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__2K241","isFull":"styles_isFull__ezn4S","isOpen":"styles_isOpen__7dtp3","dropdown":"styles_dropdown__vsasp"};